// src/pages/clients/Clients.jsx

import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import ClientsTable from "../../components/clients/ClientsTable";

const Clients = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <ClientsTable />
        </WrapperSection>
    );
};

export default Clients;